/* Ao Criar um novo perfil, a chave do perfil deve ser igual ao codigo do perfil */

export default {
  ANALISE: {
    CODIGO_MODULO: 'ANALISE',
    ANALISE: {
      codigo: 'ANALISE',
      home: '/analise'
    }
  },
  CENTRAL_DO_INTERESSADO: {
    CODIGO_MODULO: 'CENTRAL_DO_INTERESSADO',
    EXTERNO: {
      codigo: 'EXTERNO',
      home: '/central/home'
    },
    PREFEITURA: {
      codigo: 'PREFEITURA',
      home: '/central/home'
    },
    CONSULTOR_EXTERNO: {
      codigo: 'CONSULTOR_EXTERNO',
      home: '/central/home'
    },
    CONSULTOR_EXTERNO_DIVERSOS: {
      codigo: 'CONSULTOR_EXTERNO_DIVERSOS',
      home: '/central/home'
    }
  },

  ASSINATURA: {
    CODIGO_MODULO: 'ASSINATURA',
    TITULO_MODULO: 'SiCARF - Assinatura',
    ASSINADOR: {
      codigo: 'ASSINADOR',
      home: '/assinatura/home'
    }
  },
  RECEPTOR: {
    CODIGO_MODULO: 'RECEPTOR',
    TITULO_MODULO: 'SiCARF - Receptor',
    RECEPTOR: {
      codigo: 'RECEPTOR',
      home: '/receptor'
    },
    RECEPTOR_EXTERNO: {
      codigo: 'RECEPTOR_EXTERNO',
      home: '/receptor'
    }
  },
  RELATORIOS: {
    CODIGO_MODULO: 'RELATORIOS',
    TITULO_MODULO: 'Relatórios',
    RELATORIOS: {
      codigo: 'RELATORIOS',
      home: 'relatorios/home'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/perfil.js